export const FRESHDESK_WIDGET_SRC =
  'https://widget.freshworks.com/widgets/69000004104.js';

export const FRESHDESK_WIDGET_ID = 69000004104;
